module.exports = __webpack_public_path__ + "img/headerbg.b4ea9416.png";